import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const IncomingPayments = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const payments = booking.payment;

  return (
    <>
      {!isAgency && payments.receipts.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>{t("bookingDetails.payments.paymentReceipt")}</th>
              <th>{t("bookingDetails.payments.amount")}</th>
            </tr>
          </thead>

          <tbody>
            {payments.receipts.map((item, index: any) => {
              return (
                <tr key={index}>
                  <td>{item.incomingPayment}</td>
                  <td>{item.amount} {payments.currency}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
};

export default IncomingPayments;
